import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Input, Form, message, Image, Avatar, Col, Modal } from 'antd';
import { URL } from '../../../config/api';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { disableSpinner, enableSpinner } from '../../../redux/actions/appActions';
import AuthContext from '../../App/authContext';
import ModalBody from './ModalBody';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
        >
          <Input style={{width: '60px'}} />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const ExampleCard = ({modalVisible, setModalVisible}) => {
  const [results, setResults] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [update, setUpdate] = useState(0);

  const history = useHistory();
  const dispatch = useDispatch();
  const func = useContext(AuthContext);
  const [form] = Form.useForm();

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.key);
  };

  useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('id');
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    try {
      const res = await axios.post(`${URL}/get_platform.php`, bodyFormData);
      if(res.data.Success) {
        const data = res.data.Data;
        data.forEach((item, index) => {
          item.key = index
        });
        setResults(data);
      }else {
        localStorage.clear();
        alert(res.data.Message);
        history.push('/login');
        func();
      }
    }catch(error) {
      console.log(error);

    }
  }

  const openEditModal = (platform) => {
    setUpdate(update + 1);
    setEditModalVisible(true);
    setSelectedPlatform(platform);
  }

  const handleSubmit = async (values, index) => {
    console.log(values);
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('id');
    const bodyFormData = new FormData();
    bodyFormData.append('UserId', id);
    bodyFormData.append('Token', token);
    bodyFormData.append('Name', values.name);

    try {
      if(index === 0) {
        setModalVisible(false);
        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/add_platform.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      } else {
        setEditModalVisible(false);
        bodyFormData.append('PlatformId', selectedPlatform.Id);
        dispatch(enableSpinner('Loading..'));
        const res = await axios.post(`${URL}/update_platform.php`, bodyFormData);
        dispatch(disableSpinner());

        if(res.data.Success) {
          message.success(res.data.Message);
          loadResults();
        } else {
          message.error(res.data.Message);
        }
      }
    }catch(error) {
      console.log(error);
      dispatch(disableSpinner());
    }
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
    },
    {
      title: 'Edit',
      dataIndex: '',
      key: 'edit',
      fixed: 'right',
      render: (_, record) => {
        return (
          <span
            onClick={() => openEditModal(record)}
            style={{
              cursor: 'pointer',
              color: '#1890ff'
            }}
          >
          Edit
          </span>
        )
      }
    },
  ]

  return (
    <Col span={24}>
      <Card>
        <CardBody>
          <Form form={form} component={false}>
            <Table 
              components={{
                body: {
                  cell: EditableCell
                }
              }} 
              columns={columns} 
              dataSource={results} />
          </Form>
        </CardBody>
      </Card>
      <Modal
        title={`Add Platform`}
        width="30%"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => setModalVisible(false)}
        footer={null}
      >
        <ModalBody close={() => setModalVisible(false)} handleSubmit={(values) => handleSubmit(values, 0)} />
      </Modal>
      <Modal 
        title="Edit Platform"
        width="30%"
        visible={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        footer={null}>
          <ModalBody 
            close={() => {setSelectedPlatform(null); setEditModalVisible(false); }} 
            handleSubmit={(values) => handleSubmit(values, 1)}
            user={selectedPlatform}
            update={update} />
        </Modal>
    </Col>
  );
}



export default ExampleCard;
